import { StyledPageIntro } from "./styled";

function PageIntro({
  title,
  description,
  children,
  className = "",
  padding,
  margin,
}) {
  return (
    <StyledPageIntro
      className={`v2-page-intro ${className}`.trim()}
      padding={padding}
      margin={margin}
    >
      {title && <h1>{title}</h1>}
      {description && <p>{description}</p>}
      {children}
    </StyledPageIntro>
  );
}

export default PageIntro;
